// extracted by css-extract-rspack-plugin
export default {"line":"HorizontalLine_line__tbMjw"};